var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8536",
    "data-name": "Group 8536",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.006,
    height: 16,
    viewBox: "0 0 16.006 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    "data-name": "Path 930",
    d: "M9,20H5a1,1,0,0,1-1-1V15a1,1,0,0,1,2,0v3H9a1,1,0,0,1,0,2Zm5-9a1,1,0,0,1-.71-1.71l5-5A1,1,0,0,1,19.7,5.7l-5,5a1,1,0,0,1-.7.3Z",
    transform: "translate(-3.994 -4)",
    fill: "#434db8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    d: "M19,10a1,1,0,0,1-1-1V6H15a1,1,0,0,1,0-2h4a1,1,0,0,1,1,1V9A1,1,0,0,1,19,10ZM5,20a1,1,0,0,1-.71-1.71l5-5A1,1,0,0,1,10.7,14.7l-5,5A1,1,0,0,1,5,20Z",
    transform: "translate(-3.994 -4)",
    fill: "#434db8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandArrow);
export default __webpack_public_path__ + "static/media/ExpandArrow.776d7d500a114266df6adabc20fb0e90.svg";
export { ForwardRef as ReactComponent };